export default __webpack_public_path__ + "static/media/fruit.674f2380.jpg";